import { Text, TextProps, Button } from "@chakra-ui/react";
import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { FormContainer } from "../../atoms/Containers";
import { InvalidPage } from "../../atoms/InvalidPage";
import { SylaFormHeader } from "../forms/SylaFormHeader";

export type EmailVerificationNavState = {
  email: string;
};

export const EmailVerification = (): JSX.Element => {
  const { state } = useLocation<EmailVerificationNavState | undefined>();
  const { showNewMessages, update } = useIntercom();

  const message = `Hi,
I didn't receive my email verification for ${state?.email}.

Can you please help?`;

  const contactSupport = useCallback(() => {
    // set email to avoid the "which email should we contact you on?" prompt.
    update({
      userId: getRandomId(),
      email: state?.email,
    });
    showNewMessages(message);
  }, [message, showNewMessages, state, update]);

  return state?.email ? (
    <FormContainer>
      <SylaFormHeader heading={"First, let's verify your email"} />
      <Text>We just sent a verification email to {state.email}.</Text>
      <Text {...actionStyleProps} mt="10px">
        Please check your Inbox (and Spam folder!) and click the link to get
        started.
      </Text>
      <Text mt="30px">
        {"Didn't receive your email? "}
        <Button
          fontSize="revert"
          color="red.500"
          disabled={false}
          onClick={contactSupport}
          variant="link"
        >
          Contact support.
        </Button>
      </Text>
    </FormContainer>
  ) : (
    <InvalidPage />
  );
};

const actionStyleProps: TextProps = {
  fontWeight: "black",
};

// https://stackoverflow.com/a/66332305/412565
function getRandomId() {
  return URL.createObjectURL(new Blob([])).slice(-36);
}
